import { Spotlight } from '@atlaskit/onboarding';
import { Stack, Text } from '@atlaskit/primitives/compiled';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React from 'react';
import { useIntl } from 'react-intl-next';

import messages from '../messages.tsx';
import type { SpotlightTourStepProps } from '../types.tsx';

export const IntroductionStep = ({ onDismiss, onNext }: SpotlightTourStepProps) => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			actions={[
				{
					onClick: onNext,
					text: formatMessage(messages.changeboardingNextButton),
				},
				{
					appearance: 'subtle',
					onClick: onDismiss,
					text: formatMessage(messages.changeboardingDismissButton),
				},
			]}
			actionsBeforeElement="1/2"
			dialogPlacement="left top"
			dialogWidth={300}
			heading={formatMessage(messages.changeboardingTitle)}
			key="jira-filter-refinement-spotlight-popup-introduction"
			pulse={false}
			target="jira-filter-refinement-spotlight-popup"
		>
			<Stack space="space.150">
				<Text>{formatMessage(messages.changeboardingDescriptionFilterByStatusAndPriority)}</Text>
				<Text>{formatMessage(messages.changeboardingDescriptionMoreImprovements)}</Text>
			</Stack>
		</Spotlight>
	);
};
